import axiosConfig from '../../../config/axios.config';
import axios from 'axios';
import { checkResponseErrorCodeAndRedirect } from '../../../utils/errorHelper';


const trialPost = (queList, stateUpdate, settings) => {

 // const activePosts = {};
 let stop = false;
 // console.log(queList)
 const request = (index) => {
   stop = true;
   const queItem = queList[index];
   const updateStore = {
     postQue: queList.filter(queObj => queObj.dt_post_que_id !== queItem.dt_post_que_id),
   };

   const ovr = queItem.overrideEndpoint;
   const url = ovr
   ? `${axiosConfig.apiUrl}${ovr[0]}${ovr[1]}${ovr[2]}${settings.email}`
   : `${axiosConfig.apiUrl}/rt/console/${queItem.endPoint}/${settings.email}`;
   // removed 'axiosConfig.auth' as token is updated on login
   (queItem.method === 'get'
   ? axios.get(url)
   : axios.post(url,
      (queItem.data || null)
     )
   ).then(res => {
     console.log(res);
     stateUpdate(updateStore);
     if (queItem.cleanup) queItem.cleanup();
   })
   .catch(err => {
     console.error(err);
     stateUpdate(updateStore);
     if (queItem.cleanup) queItem.cleanup();
     checkResponseErrorCodeAndRedirect(err)
   })
 }

 if (queList && queList.length && !stop) {
   request(0);
 }




}


export default trialPost;

// const trialPost = (queList, stateUpdate, settings) => {
//
//  const activePosts = {};
//  let stop = false;
//  // console.log(queList)
//
//  const request = () => {
//    stop = true;
//    const { user, isCustom, reviewed } = queList[0].data;
//    const nct = queList[0].data.nct_number;
//
//    axios.post(`${axiosConfig.apiUrl}/rt/console/${queList[0].endPoint}/${settings.email}`, { nct, user, isCustom, reviewed }, axiosConfig.auth)
//    .then(res => {
//      console.log(res);
//      stateUpdate({postQue: []});
//    })
//    .catch(err => {
//      console.error(err);
//    })
//  }
//
//  if (queList && queList.length && !stop) {
//    request();
//  }
//
//
//
//
// }
//
//
// export default trialPost;
